import React, { useState } from "react";

import { appStore } from "../../../stores";
import { TextareaField } from "../../common/TextareaField";
import {
    Heading,
    SendContainer,
    UpdateAiSqlButton,
} from "./EditAnalytisModule.styles";

interface IAIInputProps {
    value: string;
    deviceIds: string[];
    onSuggestCode: (_: string) => void;
    handleChangeValue: (_: string) => void;
}

export function AIInput(props: IAIInputProps) {
    const [loading, setLoading] = useState<boolean>(false);

    const { handleChangeValue, value } = props;

    const generateAiCode = async () => {
        setLoading(true);
        appStore.setSnackbar("AI-assisted SQL suggestions are not available.");
        setLoading(false);
    };

    const handleChangeInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        handleChangeValue(e.target.value);
    };

    return (
        <>
            <SendContainer>
                <TextareaField
                    value={value}
                    placeholder="Ask here for AI suggestions"
                    onChange={handleChangeInput}
                />
            </SendContainer>

            <Heading>
                <UpdateAiSqlButton
                    loading={loading}
                    onClick={async () => {
                        await generateAiCode();
                    }}
                    disabled={
                        value === "" || value.replaceAll(" ", "").length === 0
                    }
                >
                    Update Sql
                </UpdateAiSqlButton>
            </Heading>
        </>
    );
}
